<script lang="ts">
  import Icon from '../../common/components/Icon.svelte';

  export let metaData;
  let isOpen = false;

  async function toggleAccordion() {
    isOpen = !isOpen;
  }
</script>

<div class={`home-maintenance-accordion c_${metaData?.typeCode} ${metaData?.uid}`}>
  <button class="accordion-header" on:click={toggleAccordion}>
    <span>{metaData?.title}</span>
    <span class="icon">
      <Icon type="font" glyph={isOpen ? 'chevron_up' : 'chevron_down'} mobileSize={12} desktopSize={42} />
    </span>
  </button>

  {#if isOpen}
    <div class="accordion-body">
      <div class="html-content">
        {@html metaData?.content}
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .home-maintenance-accordion:not(.preOrderFaqComponent, .preOrderTermsAndConditionsComponent) {
    border: 1px solid $secondary-gray-02;
    border-radius: 24px;
    margin-bottom: 10px;
    overflow: hidden;
    padding: 36px;
    background-color: $primary-white;
    display: flex;
    gap: 30px;
    flex-direction: column;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
    max-width: 1320px;
    margin: 0 auto;
    @include desktop-max-width {
      padding: 5px 15px;
      border-radius: 10px;
      box-shadow: none;
      margin: 0 10px;
    }
  }

  .accordion-header {
    width: 100%;
    background: $primary-white;
    border: none;
    font-size: 24px;
    font-weight: 700;
    line-height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $neutral-dark-01;
    @include desktop-max-width {
      font-size: 15px;
      line-height: 24px;
    }
  }

  .accordion-body {
    padding: 12px 16px;
    background: $primary-white;
  }

  .loading {
    color: #666;
    font-size: 13px;
  }

  .error {
    color: red;
    font-size: 13px;
  }

  .html-content {
    font-size: 14px;
    line-height: 1.5;
  }

  .icon {
    color: $icon-only-icon-blue;
  }

  :global {
    .c_CMSTabParagraphComponent {
      border: solid $neutral-dark-05 1px;
      box-shadow: none !important;
      border-radius: 12px;
      padding: 13px 21px 13px 16px;
      margin: 15px 0;
      @include desktop-min-width {
        padding: 24px 36px 22px;
      }
      .icon {
        line-height: 0;
      }
      .c_icon_new {
        color: $jood-blue-medium-01;
        font-size: 24px;
        line-height: 0;
        @include desktop-min-width {
          font-size: 35px;
        }
      }
      h3 {
        color: $neutral-dark-01;
        font-weight: 700;
        font-size: 14px;
        line-height: 26px;
        margin: 0;
        @include desktop-min-width {
          font-size: 22px;
        }
      }
      h4 {
        font-weight: 500;
        font-size: 14px;
        color: #051f2e;
        position: relative;
        text-indent: 12px;
        margin: 26px 0 12px;
        @include desktop-min-width {
          font-size: 20px;
        }
        &:before {
          content: '';
          height: 4px;
          width: 8px;
          position: absolute;
          top: 0;
          left: 0;
          margin: auto;
          bottom: 0;
          border-top: 3px solid #051f2e;
        }
      }
      p {
        border-bottom: solid 1px #d9e0e4;
        font-weight: 400;
        font-size: 16px;
        color: #051f2f;
        padding: 0 0 30px;
        margin: 0;
        @include desktop-max-width {
          font-size: 14px;
          line-height: 18px;
          padding: 0 0 26px;
        }
        &:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: none;
        }
      }
      ul {
        margin: 0;
        li {
          font-size: 16px;
          color: #051f2f;
          margin: 15px 0;
        }
      }
      .preorder-terms {
        p {
          font-weight: 500;
          padding: 0 0 16px 0;
          margin: 0;
        }
      }
      @include desktop-max-width {
        margin-left: 15px;
        margin-right: 15px;
      }
    }
  }
</style>
